<template>
  <div :id="modalStyle.id" :class="`mfp-hide ${modalStyle.class}`" ref="modal">
    <div class="popin" :style="{ maxHeight: modalHeight }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import _ from "underscore";
import $ from "jquery";
import "magnific-popup";
export default {
  name: "magnific-popup-modal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: function() {
        return {
          // magnific defaults
          disableOn: null,
          mainClass: "",
          preloader: true,
          focus: "",
          closeOnContentClick: false,
          closeOnBgClick: false,
          closeBtnInside: false,
          showCloseBtn: false,
          enableEscapeKey: true,
          modal: false,
          alignTop: false,
          index: null,
          fixedContentPos: "auto",
          fixedBgPos: "auto",
          overflowY: "auto",
          removalDelay: 0,
          autoFocusLast: true
        };
      }
    },
    modalStyle: {
      id: String,
      class: String
    }
  },
  data() {
    return {
      visible: this.show,
      modalHeight: null,
      scrollY: 0
    };
  },
  mounted() {
    this[this.visible ? "open" : "close"]();

    // モーダル高さ調整
    // let userAgent = window.navigator.userAgent.toLowerCase();
    let windowHeight = window.innerHeight;
    // if (
    //   userAgent.indexOf('msie') != -1 ||
    //   userAgent.indexOf('trident') != -1
    // ) {
    //   // IE
    // } else if(userAgent.indexOf('edge') != -1) {
    // } else if(userAgent.indexOf('chrome') != -1) {
    // } else if(userAgent.indexOf('safari') != -1) {
    // } else if(userAgent.indexOf('firefox') != -1) {
    // } else if(userAgent.indexOf('opera') != -1) {
    // } else {
    // }
    this.modalHeight = windowHeight - 300 + "px";
  },
  methods: {
    /**
     * Opens the modal
     * @param {object} options Last chance to define options on this call to Magnific Popup's open() method
     */
    open: function(options) {
      this.scrollY = window.scrollY;
      $("body").addClass("mfp-active");
      if (!!$.magnificPopup.instance.isOpen && this.visible) {
        return;
      }
      let root = this;
      let config = _.extend(
        this.config,
        {
          items: {
            src: $(this.$refs.modal),
            type: "inline"
          },
          callbacks: {
            open: function() {
              root.visible = true;
              root.$emit("open");
            },
            close: root.close
          }
        },
        options || {}
      );
      $.magnificPopup.open(config);
    },
    /**
     * Closes the modal
     */
    close: function() {
      $("body").removeClass("mfp-active");
      window.scrollTo({ top: this.scrollY, behavior: "smooth" });
      if (!$.magnificPopup.instance.isOpen && !this.visible) {
        return;
      }
      this.visible = false;
      $.magnificPopup.close();
      this.$emit("close", this.$router);
    },
    /**
     * Toggles modal open/closed
     */
    toggle: function() {
      this[this.visible ? "close" : "open"]();
    }
  }
};
</script>

<style lang="scss"></style>
